enum Frequency {
  DAILY = "daily",
  WEEKLY = "weekly",
}

export default Frequency;
